import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Label, Row, Table} from 'reactstrap';
import {getSortState, JhiItemCount, JhiPagination} from 'react-jhipster';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IRootState} from 'app/shared/reducers';

import {getEntities, getEntitiesByFilter} from './driver.reducer';
import {ITEMS_PER_PAGE} from 'app/shared/util/pagination.constants';
import {overridePaginationStateWithQueryParams} from 'app/shared/util/entity-utils';

import {hasAnyPermission} from 'app/shared/auth/permissions';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {PERMISSIONS} from 'app/config/constants';
import {getAllByType as getCountries, getAllByType} from "app/entities/region/region.reducer";
import {IRegion} from "app/shared/model/region.model";
import {convertDateTimeFromServer} from 'app/shared/util/date-utils';
import {useRegionLabels} from 'app/shared/hooks/useRegionLabels';
import {RegionDescriptionType} from 'app/shared/model/enumerations/region-description-type.model';

export interface IDriverProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const Driver = (props: IDriverProps) => {
  const [activeCountry, setActiveCountry] = useState<IRegion>()
  const {match, loading, totalItems, userCountryId} = props;
  const {driverList} = props;
  const {getLabel} = useRegionLabels();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE), props.location.search)
  );

  const [filterList, setFilterList] = useState({
    name: '',
    countryId: '',
    regionId: '',
    districtId: '',
    sort: {sortOrder: 'asc', sortType: 'firstName'}
  });
  const [countryList, setCountryList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [regionFilterList, setRegionFilterList] = useState([]);
  const [districtFilterList, setDistrictFilterList] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [nameSearchTerm, setNameSearchTerm] = useState('');

  const getAllEntities = () => {
    const filterData = {
      name: filterList.name,
      countryId: filterList.countryId,
      regionId: filterList.regionId,
      districtId: filterList.districtId,
      activePage: paginationState.activePage - 1,
      sort: {
        sortOrder: paginationState.order,
        sortType: paginationState.sort
      }
    };
    props.getEntitiesByFilter(filterData);
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    // Fetch countries, regions and districts for filtering
    Promise.resolve(props.getCountries()).then((data: any) => {
      setCountryList([...data.action.payload.data]);
    });
    Promise.resolve(props.getAllByType("REGION")).then((data: any) => {
      setRegionList([...data.action.payload.data]);
    });
    Promise.resolve(props.getAllByType("DISTRICT")).then((data: any) => {
      setDistrictList([...data.action.payload.data]);
    });
  }, []);


  useEffect(() => {
    const ac = countryList.find(country => country.id === userCountryId);
    if (ac) {
      setActiveCountry(ac);
      // Set initial country filter
      setFilterList(prev => ({
        ...prev,
        countryId: ac.id
      }));
      // Filter regions by country
      const filteredRegions = regionList.filter(region => region.parentId === ac.id);
      setRegionFilterList([...filteredRegions]);
    }
  }, [countryList, userCountryId, regionList]);

  useEffect(() => {
    if (filterList.countryId) {
      sortEntities();
      setIsInitialLoad(false);
    }
  }, [paginationState.activePage, paginationState.order, paginationState.sort, filterList.countryId]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get('sort');
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === 'asc' ? 'desc' : 'asc',
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const fetchFilteredData = (filters) => {
    const filterData = {
      name: filters.name || '',
      countryId: filters.countryId || '',
      regionId: filters.regionId || '',
      districtId: filters.districtId || '',
      activePage: 0,
      sort: {
        sortOrder: paginationState.order,
        sortType: paginationState.sort
      }
    };
    props.getEntitiesByFilter(filterData);
    setPaginationState({...paginationState, activePage: 1});
  };

  // Debounce name search with 500ms delay
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const newFilters = {
        name: nameSearchTerm,
        countryId: filterList.countryId,
        regionId: filterList.regionId,
        districtId: filterList.districtId
      };
      setFilterList(prev => ({...prev, name: nameSearchTerm}));
      if (!isInitialLoad) {
        fetchFilteredData(newFilters);
      }
    }, 500);

    // Cleanup function to cancel previous request
    return () => clearTimeout(timeoutId);
  }, [nameSearchTerm]);

  const onCountryChange = (event) => {
    const countryId = event.target.value;
    const newActiveCountry = countryList.find(country => country.id === countryId);
    setActiveCountry(newActiveCountry);

    // Reset dependent filters
    setSelectedRegion('');
    setSelectedDistrict('');
    setDistrictFilterList([]);
    setNameSearchTerm('');

    // Filter regions by selected country
    const filteredRegions = regionList.filter(region => region.parentId === countryId);
    setRegionFilterList([...filteredRegions]);

    // Update filters — the useEffect watching filterList.countryId will fire the API call
    setFilterList(prev => ({...prev, name: '', countryId, regionId: '', districtId: ''}));
    setPaginationState(prev => ({...prev, activePage: 1}));
  };

  const onRegionChange = (event) => {
    const regionId = event.target.value;
    setSelectedRegion(regionId);
    setSelectedDistrict('');
    setNameSearchTerm('');
    // Filter districts by selected region
    const filteredDistricts = districtList.filter(district => district.parentId === regionId);
    setDistrictFilterList([...filteredDistricts]);

    // Update filters — the useEffect will fire the API call
    setFilterList(prev => ({...prev, name: '', regionId, districtId: ''}));
    setPaginationState(prev => ({...prev, activePage: 1}));
  };

  const onDistrictChange = (event) => {
    const districtId = event.target.value;
    setSelectedDistrict(districtId);
    setNameSearchTerm('');

    // Update filters — the useEffect will fire the API call
    setFilterList(prev => ({...prev, name: '', districtId}));
    setPaginationState(prev => ({...prev, activePage: 1}));
  };

  const onNameChange = (event) => {
    const name = event.target.value;
    setNameSearchTerm(name);
  };

  const regCountriesList = countryList.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === activeCountry?.id;
  })

  return (
    <div>
      <h2 id="driver-heading">
        Drivers
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus"/>
          &nbsp; Create new Driver
        </Link>
      </h2>

      <br/>
      <AvForm model={{}}>
        <Row>
          {/* Country Selector */}
          {(regCountriesList && regCountriesList.length > 0) && (
            <Col md="6">
              <AvGroup>
                <Label for="driver-country">Country</Label>
                <AvInput
                  id="driver-country"
                  type="select"
                  className="form-control"
                  name="driver-country"
                  value={activeCountry?.id}
                  onChange={onCountryChange}
                >
                  {regCountriesList.map(country => (
                    <option value={country.id} key={country.id}>
                      {country.name}
                    </option>
                  ))}
                </AvInput>
              </AvGroup>
            </Col>
          )}

          {/* Region Filter */}
          <Col md="6">
            <AvGroup>
              <Label for="driver-region">{getLabel(RegionDescriptionType.REGION)}</Label>
              <AvInput
                id="driver-region"
                type="select"
                className="form-control"
                name="driver-region"
                value={selectedRegion}
                onChange={onRegionChange}
              >
                <option value="">All {getLabel(RegionDescriptionType.REGION)}s</option>
                {regionFilterList.map(region => (
                  <option value={region.id} key={region.id}>
                    {region.name}
                  </option>
                ))}
              </AvInput>
            </AvGroup>
          </Col>

          {/* District Filter */}
          <Col md="6">
            <AvGroup>
              <Label for="driver-district">{getLabel(RegionDescriptionType.DISTRICT)}</Label>
              <AvInput
                id="driver-district"
                type="select"
                className="form-control"
                name="driver-district"
                value={selectedDistrict}
                onChange={onDistrictChange}
                disabled={!selectedRegion}
              >
                <option value="">All {getLabel(RegionDescriptionType.DISTRICT)}s</option>
                {districtFilterList.map(district => (
                  <option value={district.id} key={district.id}>
                    {district.name}
                  </option>
                ))}
              </AvInput>
            </AvGroup>
          </Col>

          {/* Name Filter */}
          <Col md="6">
            <AvGroup>
              <Label for="driver-name">Search by driver name</Label>
              <AvInput
                id="driver-name"
                type="text"
                className="form-control"
                name="driver-name"
                placeholder="Search by name..."
                value={nameSearchTerm}
                onChange={onNameChange}
              />
            </AvGroup>
          </Col>
        </Row>
      </AvForm>
      <br/>

      <div className="table-responsive">
        {driverList && driverList.length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th className="hand" onClick={sort('firstName')}>
                First Name <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('lastName')}>
                Last Name <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('createdDate')}>
                Created Date <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('vehicleType.enType')}>
                Vehicle Type <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('phoneNumber')}>
                Phone Number <FontAwesomeIcon icon="sort"/>
              </th>

              <th className="hand" onClick={sort('mpesaNumber')}>
                Mobile Money ID <FontAwesomeIcon icon="sort"/>
              </th>

              <th className="hand" onClick={sort('homeVillage.name')}>
                Home {getLabel(RegionDescriptionType.VILLAGE)} <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('homeVillage.council')}>
                {getLabel(RegionDescriptionType.COUNCIL)} <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('homeVillage.council.parent')}>
                {getLabel(RegionDescriptionType.DISTRICT)} <FontAwesomeIcon icon="sort"/>
              </th>
              <th className="hand" onClick={sort('isActive')}>
                Status <FontAwesomeIcon icon="sort"/>
              </th>
              <th/>
            </tr>
            </thead>
            <tbody>
            {driverList.map((driver, i) => {
                return (
                  <tr key={`entity-${i}`}>
                    <td>{driver.firstName}</td>
                    <td>{driver.lastName}</td>
                    <td>{convertDateTimeFromServer(driver.createdDate)}</td>
                    <td>{driver.vehicleType?.enType}</td>
                    <td>{driver.phoneNumber}</td>

                    <td>{driver.mpesaNumber}</td>

                    <td>{driver?.homeVillage?.name}</td>
                    <td>{driver?.homeVillage?.council?.name}</td>
                    <td>{driver?.homeVillage?.council?.parent?.name}</td>

                    <td>{driver.activated ? 'Active' : 'Inactive'}</td>
                    <td className="text-right">
                      <div className="btn-group flex-btn-group-container">
                        <Button tag={Link} to={`${match.url}/${driver.id}`} color="info" size="sm">
                          <FontAwesomeIcon icon="eye"/> <span className="d-none d-md-inline">View</span>
                        </Button>
                        <Button
                          tag={Link}
                          to={`${match.url}/${driver.id}/edit`}
                          color="primary"
                          size="sm"
                        >
                          <FontAwesomeIcon icon="pencil-alt"/> <span className="d-none d-md-inline">Edit</span>
                        </Button>
                        {hasAnyPermission(props.permissions, [PERMISSIONS.USER_ADMIN]) &&
                          <Button
                            tag={Link}
                            to={`${match.url}/${driver.id}/delete`}
                            color="danger"
                            size="sm"
                          >
                            <FontAwesomeIcon icon="trash"/> <span className="d-none d-md-inline">Delete</span>
                          </Button>
                        }
                      </div>
                    </td>
                  </tr>
                )
              }
            )}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Drivers found</div>
        )}
      </div>
      {props.totalItems ? (
        <div className={driverList && driverList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems}
                          itemsPerPage={paginationState.itemsPerPage}/>
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={props.totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  driverList: storeState.driver.entities,
  loading: storeState.driver.loading,
  totalItems: storeState.driver.totalItems,
  permissions: storeState.authentication.permissions,
  userCountryId: storeState.authentication.userCountryId,
  isAdmin: hasAnyPermission(storeState.authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntities,
  getEntitiesByFilter,
  getCountries,
  getAllByType
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Driver);
